import React from "react";
import { useLocation } from "react-router-dom";
import Testimonials from "../components/Testimonials";
import { constants } from "../constants";

const Footer = () => {
  const location = useLocation();
  const year = new Date().getFullYear();

  return (
    <div className="flex flex-col justify-center items-center bg-[#f4f0ed] xl:py-4 lg:py-4 md:py-4 sm:py-10 xl:px-28 lg:px-28 md:px-8 sm:px-4 ">
      {[constants.route.home, constants.route.about].includes(
        location.pathname
      ) && <Testimonials />}
      <div className="xl:h-28 lg:h-28 md:h-36 sm:h-36 mx-auto flex xl:flex-row lg:flex-row md:flex-col sm:flex-col xl:max-w-325 lg:max-w-325 md:w-full sm:w-full m-auto items-center justify-between grid-cols-3 gap-6">
        <div className="text-darkLiver italic text-xl font-cormorantGaramond font-normal w-full xl:text-start lg:text-start md:text-center sm:text-center">
          360production07@gmail.com
        </div>
        <div className="flex items-center space-x-3 text-oldSilver text-base">
          <i
            className="fa-brands fa-facebook-f cursor-pointer"
            onClick={() =>
              window.open(
                "https://www.facebook.com/people/360BabyPhotography/100082413384778/",
                "_blank"
              )
            }
          />
          <div className="h-px w-8 bg-chineseSilver" />
          <i
            className="fa-brands fa-instagram cursor-pointer"
            onClick={() =>
              window.open(
                "https://www.instagram.com/360babyphotography__/?hl=en",
                "_blank"
              )
            }
          />
          <div className="h-px w-8 bg-chineseSilver" />
          <i
            className="fa-brands fa-google cursor-pointer"
            onClick={() =>
              window.open(
                "https://www.google.com/maps/uv?pb=!1s0x3be053a27fc213d5%3A0x34c1100e85c1b79c!3m1!7e115!4s%2Fmaps%2Fplace%2F360%2Bbaby%2Bphotography%2F%4021.1422496%2C72.7814707%2C3a%2C75y%2C262.29h%2C90t%2Fdata%3D*213m4*211e1*213m2*211scIPmqtf2RBHsvRJ8W7D14Q*212e0*214m2*213m1*211s0x3be053a27fc213d5%3A0x34c1100e85c1b79c%3Fsa%3DX%26ved%3D2ahUKEwjo3IerubmLAxWfTTABHcFpHKMQpx96BAhIEAA!5s360%20baby%20photography%20-%20Google%20Search!15sCgIgAQ&imagekey=!1e2!2scIPmqtf2RBHsvRJ8W7D14Q&cr=le_a7&hl=en&ved=1t%3A206134&ictx=111",
                "_blank"
              )
            }
          />
          <div className="h-px w-8 bg-chineseSilver" />
          <i
            className="fa-brands fa-whatsapp cursor-pointer"
            onClick={() =>
              window.open(
                "https://api.whatsapp.com/send/?phone=%2B919297929272&text&type=phone_number&app_absent=0",
                "_blank"
              )
            }
          />
        </div>
        <div className="text-darkLiver italic text-xl font-cormorantGaramond font-normal w-full xl:text-end lg:text-end md:text-center sm:text-center">
          &copy; {year} 360photography. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default React.memo(Footer);
